// ContactUs.js
import React from 'react';
import '.././styles.css'

const ContactUs = () => {
  return (
    <div className="legal-links">
      <h1>Contact Us</h1>
      <p>If you have any questions, concerns, or feedback regarding our website, please feel free to reach out to us. We value your input and are here to assist you.</p>

      <h2>Contact Information</h2>
      <p>Email: <a href="mailto:getfitfast1901@gmail.com">getfitfast1901@gmail.com</a></p>

      <h2>Feedback and Concerns</h2>
      <p>At GETFITFAST, we are committed to providing accurate and helpful information. If you have concerns about the content on our website, please let us know.</p>
    </div>
  );
};

export default ContactUs;
